import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Test from './Test';
import { createStore } from 'redux'; import reducer from './store/reducer';
import { Provider } from 'react-redux'; const store = createStore(reducer);

ReactDOM.render(<Provider store={store}><Test /></Provider>, document.getElementById('root'));